import canHaveTargetMedia from 'utils/canHaveTargetMedia'

export default function isOrderValid({ path, state, forms }) {
  const receivers = state.get('basket.receivers.tags')
  if (!receivers || Object.keys(receivers).length === 0) {
    return path.receivers()
  }
  let numErrors = 0
  const items = state.get('basket.basketItems')

  Object.keys(items).forEach(item => {
    const { name, ratio, target, deleted } = items[item]

    const form = forms.get(`basket.basketItems.${item}`)

    let error = null

    if (name && canHaveTargetMedia(name)) {
      if (!target.name) {
        error = { key: 'bms.orderBasket.errors.noFinalFormat' }
      }
      if (!ratio.width) {
        error = { key: 'bms.orderBasket.errors.missingRatio' }
      }
    }

    if (!form.isValid) {
      const field = Object.keys(form.getInvalidFields())[0]
      error = {
        key: `bms.orderBasket.errors.${form.getInvalidFields()[field].failedRule
          .name}`,
        params: {
          size: form.getInvalidFields()[field].failedRule.arg
        }
      }
    }

    if (deleted) {
      error = { key: 'bms.orderBasket.errors.fileDeleted' }
    }

    if (error) {
      numErrors = numErrors + 1

      state.set(`basket.basketItems.${item}.error`, { ...error })
    } else {
      state.unset(`basket.basketItems.${item}.error`)
    }
  })

  if (numErrors > 0) {
    return path.false({ numErrors })
  }

  return path.true()
}



// WEBPACK FOOTER //
// ./src/modules/Basket/actions/isOrderValid.js